import { Container, Row, Col, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  BsMegaphone,
  BsInstagram,
  BsGoogle,
  BsCode,
  BsPencilSquare,
  BsBrush,
  BsPersonBadge,
  BsCamera,
} from "react-icons/bs";
import "./ServicesPage.css";

const services = [
  {
    icon: <BsCode />,
    title: "Website Design & Development",
    desc: "Create high-converting, mobile-responsive websites designed to attract, engage, and convert visitors into leads with optimized UI/UX and fast performance.",
    included: [
      "UI/UX Design",
      "Responsive Design",
      "WordPress Development",
      "E-commerce Store",
      "Speed Optimization",
      "Lead Integration",
    ],
    tagsLabel: "Technologies We Use:",
    tags: ["Figma", "React", "Node.js", "WordPress", "Shopify"],
  },
  {
    icon: <BsInstagram />,
    title: "Social Media Marketing",
    desc: "Build a strong online presence with strategic content, consistent posting, and engagement-driven campaigns across platforms like Instagram, Facebook, and LinkedIn.",
    included: [
      "Content Strategy & Calendar",
      "Content Creation",
      "Account Management",
      "Post Scheduling",
      "Audience Engagement",
      "Performance Tracking",
    ],
    tagsLabel: "Platforms We Use:",
    tags: ["Facebook", "Instagram", "LinkedIn", "Twitter/X", "YouTube"],
  },
  {
    icon: <BsMegaphone />,
    title: "Performance Marketing",
    desc: "Drive measurable results with ROI-focused campaigns using Meta Ads and Google Ads to generate quality leads, increase conversions, and scale your business faster.",
    included: [
      "Audience Targeting",
      "Ad Creatives",
      "Campaign Setup",
      "Conversion Tracking",
      "A/B Testing",
      "ROI Optimization",
    ],
    tagsLabel: "Platforms We Use:",
    tags: [
      "Meta Ads Manager",
      "Google Ads",
      "Google Analytics",
      "Facebook Pixel",
    ],
  },
  {
    icon: <BsPersonBadge />,
    title: "LinkedIn Personal Branding",
    desc: "Position yourself as an industry authority with professional profile optimization, content strategy, and personal branding that attracts opportunities and builds trust.",
    included: [
      "Profile Optimization",
      "Content Strategy",
      "Post Creation",
      "Personal Branding",
      "Audience Engagement",
      "Lead Generation",
    ],
    tagsLabel: "Platforms We Use:",
    tags: ["LinkedIn", "Sales Navigator"],
  },
  {
    icon: <BsBrush />,
    title: "Graphic Designing & Video Editing",
    desc: "Stand out with visually compelling creatives and high-quality videos that capture attention, communicate your brand message, and boost engagement.",
    included: [
      "Social Media Creatives",
      "Logo & Brand Visuals",
      "Instagram Reels",
      "YouTube Video Editing",
      "Ad Campaign Creatives",
      "Motion Graphics",
    ],
    tagsLabel: "Technologies We Use:",
    tags: [
      "Canva",
      "InShot",
      "Adobe Photoshop",
      "Adobe Illustrator",
      "Adobe Premiere Pro",
      "After Effects",
    ],
  },
  {
    icon: <BsGoogle />,
    title: "Search Engine Optimization (SEO)",
    desc: "Improve your website's visibility on Google with on-page, off-page, and technical SEO strategies that drive organic traffic and long-term business growth.",
    included: [
      "Keyword Research",
      "On-Page SEO",
      "Technical SEO",
      "Link Building",
      "Content Optimization",
      "SEO Reporting",
    ],
    tagsLabel: "Tools We Use:",
    tags: [
      "Google Analytics",
      "Google Search Console",
      "Ahrefs",
      "SEMrush",
      "Yoast SEO",
    ],
  },
  {
    icon: <BsPencilSquare />,
    title: "Content Writing",
    desc: "Create compelling, SEO-optimized content that engages your audience, builds brand authority, and drives traffic through blogs, website copy, and marketing content tailored to your business goals.",
    included: [
      "Blog Writing",
      "Website Copy",
      "Ad Copy",
      "SEO Content",
      "Content Strategy",
      "Editing & Proofing",
    ],
    tagsLabel: "Tools We Use:",
    tags: [
      "Google Docs",
      "Grammarly",
      "ChatGPT",
      "Surfer SEO",
      "Hemingway Editor",
    ],
  },
  {
    icon: <BsCamera />,
    title: "Product Photography",
    desc: "Showcase your products with professional, high-quality visuals that enhance brand perception and increase conversions across websites and social media.",
    included: [
      "Product Shoots",
      "Lifestyle Shots",
      "White Background",
      "Creative Concepts",
      "Image Retouching",
      "Catalog Images",
    ],
    tagsLabel: "Technologies We Use:",
    tags: [
      "DSLR Cameras",
      "Studio Lighting",
      "Adobe Photoshop",
      "Adobe Lightroom",
    ],
  },
];

export const ServicesPage = () => (
  <>
    {/* Hero Banner */}
    <section className="sp-hero">
      <div className="sp-hero-orb" />
      <Container className="position-relative z-1 text-center">
        <div className="hero-badge-wrap mb-4">
          <span className="hero-badge">
            <Badge className="badge-new">What</Badge>
            We Offer
          </span>
        </div>
        <h1 className="sp-hero-title">Our Services</h1>
        <p className="sp-hero-sub">Built to Generate Leads, Not Just Traffic</p>
        <div className="hero-actions mt-4">
          <Link to="/contact" className="btn-get-in-touch-hero">
            Get Started <span className="arrow-icon">↗</span>
          </Link>
          <Link to="/projects" className="btn-view-services">
            Our Projects
          </Link>
        </div>
      </Container>
    </section>

    {/* SEO intro */}
    <section className="sp-intro">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={8}>
            <p className="sp-intro-text">
              {/* We are a full-service digital agency helping startups, SMEs, and enterprises
              build powerful online presences. From <strong>SEO and Google Ads</strong> to{' '}
              <strong>web development and social media marketing</strong>, our expert team
              delivers measurable results that grow your business. */}
              From strategy to execution, our{" "}
              <strong> digital marketing </strong> solutions are designed to
              attract the right audience, convert them into customers, and{" "}
              <strong> scale your business. </strong>
            </p>
          </Col>
        </Row>
      </Container>
    </section>

    {/* Service Cards Grid */}
    <section className="sp-cards-section">
      <Container>
        <Row className="g-4">
          {services.map((s, i) => (
            <Col key={i} md={6}>
              <article className="sp-card" aria-label={s.title}>
                {/* Icon */}
                <div className="sp-card-icon">{s.icon}</div>

                {/* Title & Desc */}
                <h2 className="sp-card-title">{s.title}</h2>
                <p className="sp-card-desc">{s.desc}</p>

                {/* What's Included */}
                <p className="sp-card-section-label">What's Included:</p>
                <ul className="sp-card-list">
                  {s.included.map((item, j) => (
                    <li key={j}>
                      <span className="sp-check" aria-hidden="true">
                        ✓
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>

                {/* Tags */}
                <p className="sp-card-section-label">{s.tagsLabel}</p>
                <div className="sp-tags">
                  {s.tags.map((t, k) => (
                    <span key={k} className="sp-tag">
                      {t}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <Link to="/contact" className="sp-card-btn">
                  Get Started →
                </Link>
              </article>
            </Col>
          ))}
        </Row>
      </Container>
    </section>

    {/* Why Choose Us + CTA */}
    <section className="sp-why">
      <Container>
        <Row className="align-items-center g-5">
          {/* Left: reasons */}
          <Col md={6}>
            <h2 className="sp-why-title">Why Choose JSR DigiMarketing?</h2>
            <ul className="sp-why-list">
              {[
                {
                  title: "Results That Matter",
                  desc: "We focus on leads, conversions, and ROI, not just likes or reach.",
                },
                {
                  title: "Tailored Growth Strategies",
                  desc: "No templates. Every strategy is custom-built for your business goals and audience.",
                },
                {
                  title: "Performance-Driven Execution",
                  desc: "Every campaign is planned and optimized to deliver consistent, measurable growth.",
                },
                {
                  title: "Clear & Honest Communication",
                  desc: "Stay informed with transparent updates, insights, and real performance data.",
                },
                {
                  title: "Consistent & Timely Delivery",
                  desc: "We ensure on-time execution with reliable and consistent performance.",
                },
                {
                  title: "Your Long-Term Growth Partner",
                  desc: "We focus on building relationships and scaling your business sustainably.",
                },
              ].map((item, i) => (
                <li key={i} className="sp-why-item">
                  <span className="sp-why-icon" aria-hidden="true">
                    ✦
                  </span>
                  <div>
                    <p className="sp-why-item-title">{item.title}</p>
                    <p className="sp-why-item-desc">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Col>

          {/* Right: CTA card */}
          <Col md={6}>
            <div className="sp-cta-card">
              <h3 className="sp-cta-title">
                Ready to Start Growing Your Business?
              </h3>
              <p className="sp-cta-sub">
                Let’s understand your requirements and create a result-driven
                strategy that generates leads and drives real business growth.
              </p>
              <ul className="sp-cta-list">
                {[
                  "Free Consultation Call",
                  "Customized Strategy Plan",
                  "Transparent Pricing",
                  "No Commitment Required",
                ].map((t, i) => (
                  <li key={i}>
                    <span className="sp-cta-check" aria-hidden="true">
                      ⊙
                    </span>
                    {t}
                  </li>
                ))}
              </ul>
              <Link to="/#contact" className="sp-cta-btn">
                Book A FREE Strategy Call
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  </>
);
